import React, { useEffect, useState } from 'react'
import { GetByReserveId_Factor_Api } from '../../API/FactorApi';
import { Button, Col, Row } from 'antd';
import '../../assets/css/factor.css';

import '../../assets/css/PrintFactorComponent.css';


// =================================================================
export const AFactorComponent = ({ setLoading, showMessage, reserveId,printType="factor" }) => {
    // =================================================================
    const [factor, setFactor] = useState();
    // =================================================================
    useEffect(() => {
        loadData();
    }, []);
    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetByReserveId_Factor_Api(reserveId);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setFactor(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    return (
        <>
            <div className="no-print">
                {
                    factor ?
                        <div className='container factor' >

                            <Row className="titleRow">
                                <Col xs={12} sm={5} md={6} lg={5} xl={5} className="titleColumn">
                                    عنوان
                                </Col>
                                <Col xs={0} sm={4} md={0} lg={4} xl={4} className="titleColumn">
                                    تعداد شب
                                </Col>
                                <Col xs={0} sm={4} md={5} lg={4} xl={4} className="titleColumn">
                                    تعداد نفرات
                                </Col>
                                <Col xs={0} sm={5} md={6} lg={5} xl={5} className="titleColumn">
                                    فی
                                </Col>
                                <Col xs={12} sm={6} md={7} lg={6} xl={6} className="titleColumn">
                                    جمع
                                </Col>
                            </Row>
                            <Row className="valueRow">
                                <Col xs={12} sm={5} md={6} lg={5} xl={5} className="valueTitle">
                                    هزینه ثابت
                                </Col>
                                <Col xs={0} sm={4} md={0} lg={4} xl={4} className="valueColumn">
                                    {factor.nightCount}
                                </Col>
                                <Col xs={0} sm={4} md={5} lg={4} xl={4} className="valueColumn">
                                    -
                                </Col>
                                <Col xs={0} sm={5} md={6} lg={5} xl={5} className="valueColumn">
                                    {factor.fixPrice.toLocaleString()}
                                </Col>
                                <Col xs={12} sm={6} md={7} lg={6} xl={6} className="valueColumn">
                                    {(factor.fixPrice * factor.nightCount).toLocaleString()}
                                </Col>
                            </Row>
                            <Row className='valueRow'>
                                <Col xs={12} sm={5} md={6} lg={5} xl={5} className="valueTitle">
                                    نفرات بزرگسال
                                </Col>
                                <Col xs={0} sm={4} md={0} lg={4} xl={4} className="valueColumn">
                                    {factor.nightCount}
                                </Col>
                                <Col xs={0} sm={4} md={5} lg={4} xl={4} className="valueColumn">
                                    {factor.personCount}
                                </Col>
                                <Col xs={0} sm={5} md={6} lg={5} xl={5} className="valueColumn">
                                    {factor.perPersonPrice.toLocaleString()}
                                </Col>
                                <Col xs={12} sm={6} md={7} lg={6} xl={6} className="valueColumn" >
                                    {(factor.nightCount * factor.personCount * factor.perPersonPrice).toLocaleString()}
                                </Col>
                            </Row>
                            <Row className='valueRow'>
                                <Col xs={12} sm={5} md={6} lg={5} xl={5} className="valueTitle">
                                    نفرات اضافه
                                </Col>
                                <Col xs={0} sm={4} md={0} lg={4} xl={4} className="valueColumn">
                                    {factor.nightCount}
                                </Col>
                                <Col xs={0} sm={4} md={5} lg={4} xl={4} className="valueColumn">
                                    {factor.extraPersonCount}
                                </Col>
                                <Col xs={0} sm={5} md={6} lg={5} xl={5} className="valueColumn">
                                    {factor.perExtraPersonPrice.toLocaleString()}
                                </Col>
                                <Col xs={12} sm={6} md={7} lg={6} xl={6} className="valueColumn" >
                                    {(factor.nightCount * factor.extraPersonCount * factor.perExtraPersonPrice).toLocaleString()}
                                </Col>
                            </Row>
                            <Row className='valueRow'>
                                <Col xs={12} sm={5} md={6} lg={5} xl={5} className="valueTitle">
                                    کودک
                                </Col>
                                <Col xs={0} sm={4} md={0} lg={4} xl={4} className="valueColumn">
                                    {factor.nightCount}
                                </Col>
                                <Col xs={0} sm={4} md={5} lg={4} xl={4} className="valueColumn">
                                    {factor.childCount}
                                </Col>
                                <Col xs={0} sm={5} md={6} lg={5} xl={5} className="valueColumn">
                                    {factor.perChildPrice.toLocaleString()}
                                </Col>
                                <Col xs={12} sm={6} md={7} lg={6} xl={6} className="valueColumn">
                                    {(factor.nightCount * factor.childCount * factor.perChildPrice).toLocaleString()}
                                </Col>
                            </Row>

                            <Row className='valueRow'>
                                <Col xs={12} sm={5} md={6} lg={5} xl={5} className="valueTitle">
                                    قابل پرداخت
                                </Col>
                                <Col xs={0} sm={13} md={11} lg={13} xl={13} >
                                </Col>
                                <Col xs={12} sm={6} md={7} lg={6} xl={6} className="sumValueColumn">
                                    {factor.payablPrice.toLocaleString()}
                                </Col>
                            </Row>
                        </div>
                        : <></>
                }
            </div>

            {factor && printType == "factor" ?
                <div className="only-print">
                    <div className="table-container">
                        <h3 style={{ textAlign: 'center' }}>
                            فاکتور
                        </h3>
                        <table className="factor-table">
                            <thead  >
                                <tr>
                                    <th  >عنوان</th>
                                    <th  >تعداد شب</th>
                                    <th >تعداد نفرات</th>
                                    <th >فی</th>
                                    <th >جمع</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(factor.fixPrice * factor.nightCount) != 0 ?
                                    <tr  >
                                        <td  >هزینه ثابت</td>
                                        <td >{factor.nightCount}</td>
                                        <td >-</td>
                                        <td > {factor.fixPrice.toLocaleString()}</td>
                                        <td >{(factor.fixPrice * factor.nightCount).toLocaleString()}</td>
                                    </tr> : <></>}

                                {(factor.nightCount * factor.personCount * factor.perPersonPrice) != 0 ?
                                    <tr  >
                                        <td  >نفرات بزرگسال </td>
                                        <td  >{factor.nightCount} </td>
                                        <td  >  {factor.personCount}</td>
                                        <td  >  {factor.perPersonPrice.toLocaleString()}</td>
                                        <td  > {(factor.nightCount * factor.personCount * factor.perPersonPrice).toLocaleString()} </td>
                                    </tr> : <></>}
                                {(factor.nightCount * factor.extraPersonCount * factor.perExtraPersonPrice) != 0 ?
                                    <tr  >
                                        <td  >نفرات اضافه</td>
                                        <td  >{factor.nightCount}</td>
                                        <td  > {factor.extraPersonCount}</td>
                                        <td  > {factor.perExtraPersonPrice.toLocaleString()}</td>
                                        <td  > {(factor.nightCount * factor.extraPersonCount * factor.perExtraPersonPrice).toLocaleString()}</td>
                                    </tr> : <></>}
                                {(factor.nightCount * factor.childCount * factor.perChildPrice) != 0 ?
                                    <tr>
                                        <td  >کودک</td>
                                        <td  > {factor.nightCount}</td>
                                        <td  > {factor.childCount}</td>
                                        <td  >{factor.perChildPrice.toLocaleString()}</td>
                                        <td  >{(factor.nightCount * factor.childCount * factor.perChildPrice).toLocaleString()}</td>
                                    </tr> : <></>}

                                <tr>
                                    <td  >قابل پرداخت</td>
                                    <td colSpan={3}> </td>
                                    <td  >  {factor.payablPrice.toLocaleString()}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div className="table-container">
                        <table className="food-table">
                            <thead>
                                <tr>
                                    <th> امضا متقاضی</th>
                                    <th>مهر و امضا مسئول امور مالی</th>
                                    <th>مهر و امضا پذیرش</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr >
                                    <td><br /><br /><br /></td>
                                    <td><br /><br /><br /></td>
                                    <td><br /><br /><br /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div> : <></>}
        </>
    )
}
